
import { usePageViewTimer } from "@shared/hooks/usePageViewTimer";
import { ActionCards } from "./ActionCards";
import { Header } from "./Header";
import { IssuesTable } from "./IssuesTable";
import { ReadingEfficiency } from "./ReadingEfficiency";
import { MeterSearch } from "./SearchMeter";
import { ValidationProgress } from "./ValidationProgress";
import { ConfigSection } from "@features/mx/validations/components/ValidationDashboard/ConfigSection";


const Dashboard = () => {
  usePageViewTimer({pageName: "MX Validation Dashboard"});
  return (
    <div className=" mx-auto space-y-8">
      <Header />
      
      <div>
        <ValidationProgress />
      </div>
      
      <div>
        <ReadingEfficiency />
      </div>
      
      <div>
        <IssuesTable />
      </div>
      
      <div>
        <MeterSearch />
      </div>
      
      <div>
        <ConfigSection />
      </div>
    </div>
  );
};

export default Dashboard;
